// components/common/InfoSection.js
import PropTypes from 'prop-types';
import React from 'react';
import { Paper } from '@mui/material';
import { SectionTitle } from './SectionTitle';

export const InfoSection = ({ title, icon: Icon, children, elevation = 1, sx = {} }) => (
    <Paper elevation={elevation} sx={{ p: 4, mb: 4, borderRadius: 2, ...sx }}>
        <SectionTitle icon={Icon} title={title} />
        {children}
    </Paper>
);

InfoSection.propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.elementType.isRequired,
    children: PropTypes.node.isRequired,
    elevation: PropTypes.number,
    sx: PropTypes.object
};

InfoSection.defaultProps = {
    elevation: 1,
    sx: {}
};
